var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLive)?_c('UIBox',{class:'asb-live',attrs:{"center":"","uncut":""}},[_vm._v("\n  "+_vm._s(_vm.translations['Frontend type'].Live)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }